<template>
    <div>
        <input :type="type" v-model="password" maxlength="20" @keyup="keyUp" class="form-control" :class="{ 'is-valid': isValid }" :placeholder="$t('pass_enter')" :name="nombre" ref="newpasswordr">
        <a href="#" class="show-pass border-0 bg-transparent" @click.prevent="showPassword">
            <svg width="24" height="24" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" focusable="false">
                <path opacity=".3" d="M12 6a9.77 9.77 0 00-8.82 5.5C4.83 14.87 8.21 17 12 17s7.17-2.13 8.82-5.5A9.77 9.77 0 0012 6zm0 10c-2.48 0-4.5-2.02-4.5-4.5S9.52 7 12 7s4.5 2.02 4.5 4.5S14.48 16 12 16z"></path>
                <path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 13a9.77 9.77 0 01-8.82-5.5C4.83 8.13 8.21 6 12 6s7.17 2.13 8.82 5.5A9.77 9.77 0 0112 17zm0-10c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7zm0 7a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"></path>
                <line v-show="type == 'text'" x1="3" y1="3" x2="21" y2="21" />
            </svg>
        </a>
        <div class="strength-meter">
            <div class="strength-meter-fill" :data-score="score"></div>
        </div>
        <div v-show="txtInfo" class="text-muted"><small>{{txtInfo}}</small></div>
    </div>
</template>

<script>
    export default {
        name: 'mmPassword',
        props: ['configPatron', 'nombre', 'value'],
        data() {
            return {
                password: '',
                score: -1,
                symbols: '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~',
                txtInfo: '',
                isValid: false,
                type: 'password'
            }
        },
        methods: {
            showPassword() {
				this.type = this.type === 'password' ? 'text' : 'password';
			},
            keyUp() {
                //5 es la maxima puntuacion, dependiendo el patron calculamos la correlacion
                this.score = Math.ceil(this.calculateScore()*5/this.maxScore());
                this.isValid = this.score == 5;
                this.$emit('input', this.isValid ? this.password : 'null')
            },
            calculateScore() {
                let _score = 0;
                this.txtInfo = this.$i18n.t('pass_good');

                if (this.password.length==0) return 0;

                if (this.configPatron.username != '' && this.password.toUpperCase().indexOf(this.configPatron.username.toUpperCase()) >= 0) {
                    this.txtInfo = this.$i18n.t('pass_containsUsername');
                    return 0;
                }

                if (this.password.length >= this.configPatron.minimumLength) _score++; 
                else this.txtInfo = this.$i18n.t('shortPass', {n: this.configPatron.minimumLength});

                if (this.configPatron.reqSymbol == 1) {
                    var re = new RegExp("([" + this.symbols + "])");
                    if (re.test(this.password)) _score++; 
                    else this.txtInfo = this.$i18n.t('pass_symbol', {s: this.symbols});
                }

                if (this.configPatron.reqUpper == 1) {
                    if (this.password.match(/([A-Z])/)) _score++; 
                    else this.txtInfo = this.$i18n.t('pass_upper');
                }

                if (this.configPatron.reqLower == 1) {
                    if (this.password.match(/([a-z])/)) _score++; 
                    else this.txtInfo = this.$i18n.t('pass_lower');
                }

                if(this.configPatron.reqNumber == 1) {
                    if (this.password.match(/([0-9])/)) _score++; 
                    else this.txtInfo = this.$i18n.t('pass_number');
                }
                
                return _score;
            },
            maxScore(){
                return 1 + parseInt(this.configPatron.reqSymbol) + parseInt(this.configPatron.reqLower) + parseInt(this.configPatron.reqUpper) + parseInt(this.configPatron.reqNumber);
            }
        },
        watch: {
            value: function(v) {
                
                if(!v) {
                    this.password = '';
                    this.score = -1;
                    this.isValid = false;
                }
            }
        }
    }
</script>

<style lang="scss">
    .strength-meter {
        position: relative;
        height: 3px;
        background: #ddd;
        margin: 3px auto;
        border-radius: 3px;

        &::before, &::after {
            content: "";
            height: inherit;
            background: transparent;
            display: block;
            border-color: #fff;
            border-style: solid;
            border-width: 0 5px;
            position: absolute;
            width: calc(100%/4);
            z-index: 10;
        }
        &::before {
            left: calc(100%/4);
        }
        &::after {
            right: calc(100%/4);
        }
    }
    .strength-meter-fill {
        background: transparent;
        height: inherit;
        position: absolute;
        width: 0;
        border-radius: inherit;
        transition: width .5s ease-in-out,background .25s;
        
        &[data-score="0"] {
            background: #650000;
            width: 5%;
        }
        &[data-score="1"] {
            background: darkred;
            width: 20%;
        }
        &[data-score="2"] {
            background: #ff4500;
            width: 40%;
        }
        &[data-score="3"] {
            background: orange;
            width: 60%;
        }
        &[data-score="4"] {
            background: #9acd32;
            width: 80%;
        }
        &[data-score="5"] {
            background: green;
            width: 100%;
        }
    }
</style>